const getTotalPayment = (data) => {
    const totalFare = data.airReservation.priceInfo.itinTotalFare[0];

    return {
        headItem: {
            description: "Tarifa"
        },
        items: [
            { description: "Base", amountText:`US$ ${totalFare.baseFare.amount.toFixed(2)}` },
            { description: "Impuestos y tasas", amountText: `US$ ${totalFare.taxes.amount.toFixed(2)}`},
            { description: "Penalidad", amountText: `US$ ${totalFare.fees.amount.toFixed(2)}`}
        ],
        finalItem: {
            description: "Total a pagar",
            amountText: `US$ ${totalFare.totalFare.amount.toFixed(2)}`
        }
    };
};

export default getTotalPayment;